import request from '@/utils/request'

export function GetList() {
  return request({
    url: '/api/PowerSet/GetList',
    method: 'get'
  })
}
